import { useCallback, useSyncExternalStore } from 'react';
import {
  EMPTY_ENTRY,
  subscribeToCylindoStore,
  getCylindoEntry,
  requestCylindoFetch,
} from './utils';

const useCylindoCache = (productId, isCylindoProduct) => {
  if (productId && isCylindoProduct) {
    requestCylindoFetch(productId);
  }

  const getSnapshot = useCallback(() => getCylindoEntry(productId), [
    productId,
  ]);

  const getServerSnapshot = useCallback(() => EMPTY_ENTRY, []);

  const { config, version, loading } = useSyncExternalStore(
    subscribeToCylindoStore,
    getSnapshot,
    getServerSnapshot
  );

  return { config, version, loading };
};

export default useCylindoCache;
